import { DisplayInputValue, EmptyRequiredFieldCount } from '@reapitform/dashboard-ui'
import React from 'react'
import { IAgentSettingsData } from '../../../../../api/agent-settings'
import { css } from '@linaria/core'
import { businessDetailsValidationSchema } from '../edit-form'
import { FlexContainer } from '@reapit/elements'

const BusinessDetailsDisplayView: React.FC<{ data?: null | IAgentSettingsData['details'] }> = ({ data }) => {
  if (!data) return

  const logoFieldHeight = css`
    height: 62px;
  `
  const logoImageStyle = css`
    width: auto;
    height: 100%;
    object-fit: contain;
  `
  return (
    <>
      <EmptyRequiredFieldCount validationSchema={businessDetailsValidationSchema} value={data} />
      <FlexContainer isFlexColumn>
        <DisplayInputValue title="Business Name" isEmpty={!data.businessName}>
          {data.businessName}
        </DisplayInputValue>
        <DisplayInputValue title="Trading Name" isEmpty={!data.tradingName}>
          {data.tradingName}
        </DisplayInputValue>
        <DisplayInputValue title="ABN" isEmpty={!data.abn}>
          {data.abn}
        </DisplayInputValue>
        <DisplayInputValue title="ACN" isEmpty={!data.acn}>
          {data.acn}
        </DisplayInputValue>
        <DisplayInputValue title="Logo" className={logoFieldHeight} isEmpty={!data.logo?.link?.url}>
          <img src={data.logo?.link?.url} alt="logo" className={logoImageStyle} />
        </DisplayInputValue>
      </FlexContainer>
    </>
  )
}

export default BusinessDetailsDisplayView
